import React, { useState, useEffect } from "react";

import { Form} from "react-bootstrap";
import Select from "react-select";

import authenticatedFetch from "./fetch"

const SpecialtySelect = ({ handleSpecialtiesChanged, selectedSpecialties, forceRefresh, path}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
      authenticatedFetch({
          path: "specialty/" + path,
              successHandler: function(result) {
              setIsLoaded(true);
              setData(result);
          },
          errorHandler: function(error) {
              setIsLoaded(true);
              setError(error);
          }
      });
  }, [path, forceRefresh])

  const options = React.useMemo(() => {
      const options = new Set();
      if(isLoaded && !error && data)
      {
        data.forEach((specialty) => {
          options.add({value: specialty.id, label: specialty.code + ": " + specialty.name});
        });
        return [...options.values()];
      }
      return []
  }, [data]);

  if (!isLoaded)
  {
    return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
  }
  else if (error || !data)
  {
    return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
  }
  else
  {
      const customStyles = {
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: "0 5px 0 0",
        }),
        clearIndicator: (styles) => ({
            ...styles,
            padding: 0,
        })
      }

      return (
          <div style={{marginRight: "22px"}}>
              <Select
              options={options}
              styles={customStyles}
              onChange={(values) => {
                handleSpecialtiesChanged(values);
              }}
              value={selectedSpecialties}
              placeholder="Select taxonomies..."
              isMulti
              theme={(theme) => ({
                ...theme,
                colors: {
                ...theme.colors,
                  primary50: '#DEF2F1',
                  primary25: '#DEF2F1',
                  primary: '#3AAFA9',
                },
              })}
              />
          </div>
      )
  }
}

export default SpecialtySelect;